import React from "react";

import { useTranslation } from "utils";

import { Icon, Tooltip } from "components";

type RotationCycleMarkerProps = {
  className: string;
};

/** Marks the row where the crop rotation starts over. Shared by the detail and compare tables. */
export const RotationCycleMarker = ({ className }: RotationCycleMarkerProps) => {
  const { t } = useTranslation("scenarioAnalysis");
  const label = t("detailedCalculations.rotationRepeats");

  return (
    <Tooltip title={label} placement="top">
      <span className={className} aria-label={label}>
        <Icon iconName="tabler/refresh" size="xs" />
      </span>
    </Tooltip>
  );
};

export default RotationCycleMarker;
